import request from '@/utils/request'

// api地址
const api = {
  page: '/rnt/batteryBms/page'
}

/**
 * 根据id查询
 * @param id id
 * @returns {Promise<Object>}
 */
export function page(params) {
  return new Promise((resolve, reject) => {
    request.get(api.page, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(e => {
      reject(e)
    })
  })
}
